export default "__VITE_ASSET__DCTIq$5u__"